module.exports = "<svg><circle cx=\"50%\" cy=\"50%\" r=\"40%\" stroke=\"black\" stroke-width=\"3\" fill=\"transparent\"></circle></svg>"